<div class="message-container text-center">
  <div class="header">Page Not Found</div>
  <div>Sorry, we can't find that page. Please double check your URL or use the site navigation to find what you need.</div>
  <div class="button-container"><app-button text="TAKE ME HOME" (onClick)="gotoDashboard()"></app-button></div>
</div>